import { useEffect, useRef, useState } from "react";
import axios from "../api/axios";
import { useReactToPrint } from 'react-to-print';
import Select from "react-select";
import { Button, Row, Col, Modal, message, Alert } from "antd";
import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import AprExportButtons from "./APR_ReportTablesComponents/AprExportButtons";
import { downloadAprReportExcel, downloadAprReportWord } from "../utils/aprOfficeExport";
import Annex2a from "./RCC_APR_ReportTablesComponents/Annex2a";
import Annex2b from "./RCC_APR_ReportTablesComponents/Annex2b";
import Annex3b from "./RCC_APR_ReportTablesComponents/Annex3b";
import Annex3c from "./RCC_APR_ReportTablesComponents/Annex3c";
import Annex4a from "./RCC_APR_ReportTablesComponents/Annex4a";
import Annex5a from "./RCC_APR_ReportTablesComponents/Annex5a";
import Annex6a from "./RCC_APR_ReportTablesComponents/Annex6a";
import Annex7a from "./RCC_APR_ReportTablesComponents/Annex7a";
import Annex7c from "./RCC_APR_ReportTablesComponents/Annex7c";
import Annex8a from "./RCC_APR_ReportTablesComponents/Annex8a";
import Annex8b from "./RCC_APR_ReportTablesComponents/Annex8b";
import Annex8c from "./RCC_APR_ReportTablesComponents/Annex8c";
import Annex9a from "./RCC_APR_ReportTablesComponents/Annex9a";

import ReportCover from "./APR_ReportTablesComponents/ReportCover";
import useAuth from "../hooks/useAuth";
import instance from "../api/cmsapi";
import { useLocationContext } from "../context/LocationContext";
import WorkFlowComponent from "./RCC_APR_ReportTablesComponents/APRComment.js/WorkFlowComponent";
import Annex5b from "./RCC_APR_ReportTablesComponents/Annex5b";
import { set } from "date-fns";
import {
  APR_PRINT_PAGE_STYLE,
  prepareAprPrintRoot,
  restoreAprPrintRoot,
} from "../utils/aprPrintStyles";
import "../styles/apr-report-workspace.css";

// List of Tables options
const tableOptions = [
  { value: "all_tables", label: "All Tables" },
  { value: "table_1", label: "Annex 2a – Details on the RCC Annual Action Plan Implemented" },
  { value: "table_2", label: "Annex 2b – Proportion of the MTDP implemented" },
  { value: "table_3", label: "Annex 3b – Repair and Maintenance of Existing Infrastructure" },
  { value: "table_4", label: "Annex 3c – Register of Key Regional Programmes" },
  { value: "table_5", label: "Annex 4a – Update On Revenue Sources and Expenditure" },
  { value: "table_5b", label: "Annex 5b – Update On Human Resource Issues and Logistics" },
  { value: "table_6", label: "ANNEX 5a – Update on Expenditure" },
  { value: "table_7", label: "Annex 6a – Regional Performance of Core Indicators" },
  { value: "table_8", label: "Table 8 – Updates on Critical Development and Poverty Issues in the Year 2025" },
  { value: "table_9", label: "Table 9 – Staff Development (Capacity Building /Training)" },
  { value: "table_10", label: "Table 10 – Staff Strength of the RCC" },
  { value: "table_11", label: "Table 11 – Update on key Logistics" },
  { value: "table_12", label: "Table 12 – Evaluations Conducted, their findings and Recommendations" },
  { value: "table_13", label: "ANNEX 9: UPDATE ON PM&E CONDUCTED" },
];

const periodOption = [
  { value: "Q1", label: "First Quarter - Q1" },
  { value: "Q2", label: "Second Quarter - Q2" },
  { value: "Q3", label: "Third Quarter - Q3" },
  { value: "Q4", label: "Fourth Quarter - Q4" },
  { value: "Y", label: "Yearly" }
];

const Abbreviation = [
  { value: "1D1F", label: "1D1F - One District One Factory" },
  { value: "AAP", label: "AAP - Annual Action Plan" },
  { value: "AIDS", label: "AIDS - Acquired Immune Deficiency Syndrome" },
  { value: "AMSEC", label: "AMSEC - Agricultural Mechanisation Services" },
  { value: "APR", label: "APR - Annual Progress Report" },
  { value: "ART", label: "ART - Anti-Retroviral Treatment" },
  { value: "BECE", label: "BECE - Basic Education Certificate Examination" },
  { value: "CAPEX", label: "CAPEX - Capital Expenditure" },
  { value: "CLTS", label: "CLTS - Community Led Total Sanitation" },
  { value: "CHPS", label: "CHPS - Community-Based Health Planning and Services" },
  { value: "COVID", label: "COVID - Corona Virus Disease" },
  { value: "CSOs", label: "CSOs - Civil Society Organisations" },
  { value: "DACF", label: "DACF - District Assemblies’ Common Fund" },
  { value: "DACF-RFG", label: "DACF-RFG - District Assemblies’ Common Fund Responsiveness Factor Grant" },
  { value: "EXECO", label: "EXECO - Executive Committee" },
  { value: "GHS", label: "GHS - Ghana Cedis" },
  { value: "GoG", label: "GoG - Government of Ghana" },
  { value: "HIV", label: "HIV - Human Immunodeficiency Virus" },
  { value: "HoDs", label: "HoDs - Head of Departments" },
  { value: "IGF", label: "IGF - Internally Generated Fund" },
  { value: "ISSOP", label: "ISSOP - Integrated Social Services Operating Procedure" },
  { value: "JHS", label: "JHS - Junior High School" },
  { value: "LEAP", label: "LEAP - Livelihood Empowerment Against Poverty" },
  { value: "LLINs", label: "LLINs - Long-Lasting Insecticidal Nets" },
  { value: "MAC", label: "MAC - Municipal AIDS Committee" },
  { value: "MAG", label: "MAG - Modernising Agriculture in Ghana" },
  { value: "MCD", label: "MCD - Municipal Co-ordinating Director" },
  { value: "MCE", label: "MCE - Municipal Chief Executive" },
  { value: "M&E", label: "M&E - Monitoring and Evaluation" },
  { value: "MMTDP", label: "MMTDP - Municipal Medium-Term Development Plan" },
  { value: "MP’s CF", label: "MP’s CF - Member of Parliament’s Common Fund" },
  { value: "MPCU", label: "MPCU - Municipal Planning Coordinating Unit" },
  { value: "MSEs", label: "MSEs - Micro and Small Enterprises" },
  { value: "MTDP", label: "MTDP - Medium-Term Development Plan" },
  { value: "MUSEC", label: "MUSEC - Municipal Security Council" },
  { value: "NDPC", label: "NDPC - National Development Planning Commission" },
  { value: "NGOs", label: "NGOs - Non-Governmental Organizations" },
  { value: "NHIS", label: "NHIS - National Health Insurance Scheme" },
  { value: "NSMA", label: "NSMA - Nkwanta South Municipal Assembly" },
  { value: "ORCC", label: "ORCC - Oti Regional Coordinating Council" },
  { value: "PERD", label: "PERD - Planting for Export and Rural Development" },
  { value: "PM&E", label: "PM&E - Participatory Monitoring and Evaluation" },
  { value: "PMTCT", label: "PMTCT - Prevention of Mother to Child Transmission" },
  { value: "PWDs", label: "PWDs- Persons With Disabilities" },
  { value: "SHS", label: "SHS - Senior High School" },
  { value: "SOCO", label: "SOCO - Gulf of Guinea Northern Regions Social Cohesion Project" },
  { value: "SPSS", label: "SPSS - Scientific Package for Social Scientist" },
];

function resolveContextDistrict(currentLocation, orgTree) {
  if (!currentLocation) return null;

  if (currentLocation.level === "region") {
    return { value: currentLocation.orgUnitId, label: currentLocation.name }
  }

  return null;
}

function getRegionName(currentLocation) {
  if (!currentLocation) return null;

  return currentLocation.level === "region" ? currentLocation.name : null;
}

function AprReport({ embedded = false }) {

  const [dataElements, setDataElements] = useState(null);
  const [economicDataElements, setEconomicDataElements] = useState(null);
  const [socialDataElements, setSocialDataElements] = useState(null);
  const [categories, setCategories] = useState(null);
  const [districtWideConstant, setDistrictWideConstant] = useState(null);
  const [districts, setDistricts] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedYear, setSelectedYear] = useState({ value: "2025", label: "2025" });
  const [selectedPeriod, setSelectedPeriod] = useState({ value: "Y", label: "Yearly" });
  const [selectedABB, setSelectedABB] = useState({ value: "Abbreviation", label: "List of Abbreviations" });
  const [selectedTocSection, setSelectedTocSection] = useState(null);
  const contentToPrint = useRef(null);
  const [progressLoad, setProgressLoad] = useState(false);

  const [assessmentStatus, setAssessmentStatus] = useState(null);
  const { user } = useAuth();
  const { currentLocation, orgTree } = useLocationContext();
  const currentUserRole = user?.user?.userRoles?.find(
    (role) =>
      role.name === "APR USER" ||
      role.name === "RCC USER" ||
      role.name === "APR DCE" ||
      role.name === "NDPC USER"
  )?.name || "";

  const normalizedUserRole = currentUserRole ? currentUserRole.replace(/ /g, "_").toUpperCase() : "";

  const rccUserRole = user?.user?.userRoles?.find((role) => role.name === "RCC USER" || role.name === "Superuser") || null;
  const isSuperuser = (user?.user?.userRoles || []).some((role) => role.name === "Superuser");
  const isRccUser = normalizedUserRole === "RCC_USER";
  const isAprDceUser = normalizedUserRole === "APR_DCE";
  const isNdpcUser = normalizedUserRole === "NDPC_USER";
  const canStartRccReport = isRccUser || isSuperuser;
  const canSubmitToDce = isRccUser || isSuperuser;
  const canReviewAsDce = isAprDceUser || isSuperuser;
  const canCloseAsNdpc = isNdpcUser || isSuperuser;

  // Set "All Tables" as the default selected table
  const [selectedTable, setSelectedTable] = useState({ value: "all_tables", label: "All Tables" });

  // Year options for dropdown
  const yearOptions = (() => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 5;
    return Array.from({ length: 6 }, (_, i) => {
      const year = startYear + i;
      return { value: year.toString(), label: year.toString() };
    });
  })();

  // Helper function to format period for filename
  const getPeriodLabel = () => {
    if (selectedPeriod?.value === "yearly") {
      return "Annual";
    }
    return selectedPeriod?.label?.split(" - ")[0] || selectedPeriod?.value || "Yearly";
  };

  // Notification configuration based on assessment status
  const getNotificationConfig = () => {
    if (!assessmentStatus) return null;
    
    switch (assessmentStatus.status) {
      case "Start":
        return {
          type: "info",
          icon: <ClockCircleOutlined />,
          message: "Report Status: In Progress",
          description: "Complete the RCC progress report and submit it to APR DCE for validation.",
          show: true
        };
      case "Pending":
        return {
          type: "warning",
          icon: <ClockCircleOutlined />,
          message: "Report Status: Pending APR DCE Review",
          description: "This report is awaiting APR DCE validation, comments, and approval or rejection.",
          show: true
        };
      case "Completed":
        return {
          type: "success",
          icon: <CheckCircleOutlined />,
          message: "Report Status: Completed",
          description: "This report has been approved by APR DCE and forwarded to NDPC.",
          show: true
        };
      case "Closed":
        return {
          type: "error",
          icon: <CloseCircleOutlined />,
          message: "Report Status: Closed",
          description: "This report has been closed. No further changes can be made.",
          show: true
        };
      default:
        return null;
    }
  };

  const notificationConfig = getNotificationConfig();

  useEffect(() => {
    if (!embedded) return;

    const nextDistrict = resolveContextDistrict(currentLocation, orgTree);
    const regionName = getRegionName(currentLocation);

    setSelectedRegion(regionName);

    setSelectedDistrict((previousDistrict) => {
      if (
        previousDistrict?.value === nextDistrict?.value &&
        previousDistrict?.label === nextDistrict?.label
      ) {
        return previousDistrict;
      }
      return nextDistrict;
    });
  }, [embedded, currentLocation, orgTree]);


  useEffect(() => {
    const fetchAssessmentStatus = async () => {
      try {
        const response = await instance.get(
          `assessments/dpat/${selectedDistrict?.value}/${selectedYear?.value}/RCC_APR_${selectedPeriod?.value || "Y"}`
        );
        setAssessmentStatus(response.data);
      } catch (error) {
        console.error("Failed to fetch assessment status:", error);
        setAssessmentStatus(null);
      }
    };

    if (selectedDistrict?.value && selectedYear?.value) {
      fetchAssessmentStatus();
    } else {
      setAssessmentStatus(null);
    }
  }, [selectedDistrict, selectedYear, selectedPeriod]);

  useEffect(() => {
    pullConstantData();
  }, []);

  useEffect(() => {
    if (!embedded) {
      getData();
    }
  }, [embedded]);

  useEffect(() => {
    if (selectedDistrict && selectedYear) {
      getDistrictWideConstant(selectedDistrict.value, selectedYear.value)
    }
  }, [selectedDistrict, selectedYear]);

  // Updated handlePrint with year and period in filename
  const handlePrint = useReactToPrint({
    content: () => contentToPrint.current,
    documentTitle: `${selectedDistrict?.label || "RCC"}_APR_Report_${selectedYear?.value || "Year"}_${getPeriodLabel()}`,
    pageStyle: APR_PRINT_PAGE_STYLE,
    onBeforeGetContent: () => {
      prepareAprPrintRoot(contentToPrint.current);
      const canvases = contentToPrint.current?.querySelectorAll?.("canvas") || [];
      canvases.forEach((canvas) => {
        if (canvas.width === 0 || canvas.height === 0) {
          canvas.width = 800;
          canvas.height = 400;
          canvas.style.width = "800px";
          canvas.style.height = "400px";
        }
      });
      return Promise.resolve();
    },
    onAfterPrint: () => {
      restoreAprPrintRoot(contentToPrint.current);
    },
    onPrintError: (errorLocation, error) => {
      restoreAprPrintRoot(contentToPrint.current);
      console.error("Print error:", errorLocation, error);
      message.error("Failed to generate PDF. Please try again.");
    },
    removeAfterPrint: true,
  });

  function pullConstantData() {
    axios.get('/dataSets/saljkJMizBZ?fields=dataSetElements[dataElement[id,name]]&paging=false')
      .then(response => {
        setDataElements(response.data.dataSetElements);
      }).catch(err => {
        console.error("Error pulling Data Elements: ", err);
      });

    axios.get('/dataSets/Xj0f6QZwYeO?fields=dataSetElements[dataElement[id,name]]&paging=false')
      .then(response => {
        setEconomicDataElements(response.data.dataSetElements);
      }).catch(err => {
        console.error("Error pulling Data Elements: ", err);
      });

    axios.get('/dataSets/cfMIscR3rdL?fields=dataSetElements[dataElement[id,name]]&paging=false')
      .then(response => {
        setSocialDataElements(response.data.dataSetElements);
      }).catch(err => {
        console.error("Error pulling Data Elements: ", err);
      });

    axios.get('/categoryOptionCombos.json?fields=id,name&paging=false')
      .then(response => {
        setCategories(response.data.categoryOptionCombos);
      }).catch(err => {
        console.error("Error pulling Category Combination:", err);
      });
  }

  function getDistrictWideConstant(district, year) {
    axios
      .get(`/dataValueSets?dataSet=saljkJMizBZ&orgUnit=${district}&startDate=${year}-01-01&endDate=${year}-12-31`)
      .then(result => {
        setDistrictWideConstant(result.data.dataValues);
      })
      .catch(err => {
        console.log(err);
      });
  }

  function getData() {
    const storedDistricts = localStorage.getItem("districts");
    if (storedDistricts) {
      const parsedDistricts = JSON.parse(storedDistricts);
      setDistricts(parsedDistricts);
      if (parsedDistricts.length > 0 && !selectedDistrict) {
        setSelectedDistrict(parsedDistricts[0]);
      }
      return;
    }

    axios
      .get("https://dddp.gov.gh/api/organisationUnits?level=3&paging=false")
      .then((result) => {
        let temp = [];
        result.data.organisationUnits.forEach((district) => {
          const currentDistrict = { value: district.id, label: district.displayName };
          temp.push(currentDistrict);
        });

        localStorage.setItem("districts", JSON.stringify(temp));
        setDistricts(temp);
        if (temp.length > 0 && !selectedDistrict) {
          setSelectedDistrict(temp[0]);
        }
      })
      .catch((err) => console.log(err));
  }


  const handleStartAPR = async () => {
    setProgressLoad(true);

    const payload = {
      id: 0,
      username: user?.user?.username || "",
      fullName: user?.user?.fullName || "",
      userRole: rccUserRole ? rccUserRole.name : "",
      type: `RCC_APR_${selectedPeriod?.value || "Y"}`,
      districtId: selectedDistrict?.value || "",
      year: selectedYear?.value || "",
      status: "Start",
      assessmentStartDate: new Date().toISOString().split("T")[0],
      assessmentEndDate: null,
      reviewStartDate: null,
      reviewEndDate: null,
      closedDate: null,
    };

    try {
      const assessmentResponse = await instance.post(`assessments`, payload);
      setAssessmentStatus(assessmentResponse.data);
      message.success({
        content: (
          <div>
            <p>Assessment started successfully</p>
          </div>
        ),
        duration: 3,
      });

    } catch (error) {
      console.error("Failed to process report or comment:", {
        // message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      // message.error(`Failed to process: ${error.response?.data?.message || error.message}`);
    } finally {
      setProgressLoad(false);
    }
  };

  const handlePendingAPR = async () => {
    setProgressLoad(true);
    const assessmentEndDate = new Date().toISOString().split("T")[0];
    const assessmentStartDate = assessmentStatus?.assessmentStartDate || assessmentEndDate;

    const payload = {
      id: assessmentStatus.id,
      username: user?.user?.username,
      fullName: user?.user?.fullName,
      userRole: normalizedUserRole,
      type: assessmentStatus.type || `RCC_APR_${selectedPeriod?.value || "Y"}`,
      districtId: selectedDistrict?.value,
      year: assessmentStatus.year || selectedYear?.value,
      status: "Pending",
      assessmentStartDate,
      assessmentEndDate,
      reviewStartDate: assessmentEndDate,
      reviewEndDate: null,
      closedDate: null,
    };

    try {
      const response = await instance.put(`assessments/${payload.id}`, payload);
      setAssessmentStatus(response.data);
      message.success({
        content: (
          <div>
            <p>Progress Report submitted to APR DCE successfully</p>
          </div>
        ),
        duration: 3,
      });
    } catch (error) {
      console.error("Failed to Submit Report:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      message.error(`Failed to Submit Report: ${error.response?.data?.message || error.message}`);
    } finally {
      setProgressLoad(false);
    }
  };

  const handleCompleteAPR = async () => {
    setProgressLoad(true);
    const reviewEndDate = new Date().toISOString().split("T")[0];
    const assessmentEndDate = new Date().toISOString().split("T")[0];
    const assessmentStartDate = assessmentStatus?.assessmentStartDate || new Date().toISOString().split("T")[0]; // Use existing start date or fallback to today

    const payload = {
      id: assessmentStatus.id,
      username: user?.user?.username,
      fullName: user?.user?.fullName,
      userRole: normalizedUserRole,
      // userRole: "DDDP_USER",
      type: assessmentStatus.type,
      districtId: selectedDistrict?.value,
      year: assessmentStatus.year,
      status: "Completed",
      assessmentStartDate: assessmentStartDate,
      assessmentEndDate: assessmentEndDate,
      reviewStartDate: assessmentStatus?.reviewStartDate || assessmentEndDate, // Use existing review start date or fallback to assessmentEndDate
      reviewEndDate: reviewEndDate,
      closedDate: null,
    };


    try {
      // Step 1: Update assessment with PUT request
      const response = await instance.put(`assessments/${payload.id}`, payload);
      setAssessmentStatus(response.data);
      message.success({
        content: (
          <div>
            <p>RCC Progress Report approved and forwarded to NDPC</p>
          </div>
        ),
        duration: 3,
      });


    } catch (error) {
      console.error("Failed to Submit Report:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      message.error(`Failed to Submit Report: ${error.response?.data?.message || error.message}`);
    } finally {
      setProgressLoad(false);
    }
  };

  const handleSendBackAPR = async () => {
    setProgressLoad(true);
    const assessmentStartDate = assessmentStatus?.assessmentStartDate || new Date().toISOString().split("T")[0];
    const payload = {
      id: assessmentStatus?.id,
      username: user?.user?.username,
      fullName: user?.user?.fullName,
      userRole: normalizedUserRole,
      type: assessmentStatus?.type || `RCC_APR_${selectedPeriod?.value || "Y"}`,
      districtId: selectedDistrict?.value,
      year: assessmentStatus?.year || selectedYear?.value,
      status: "Start",
      assessmentStartDate,
      assessmentEndDate: null,
      reviewStartDate: null,
      reviewEndDate: null,
      closedDate: null,
    };

    try {
      const response = await instance.put(`assessments/${payload.id}`, payload);
      setAssessmentStatus(response.data);
      message.success("Report sent back to RCC for improvement");
    } catch (error) {
      console.error("Failed to send report back:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      message.error(`Failed to send back report: ${error.response?.data?.message || error.message}`);
    } finally {
      setProgressLoad(false);
    }
  };

  const handleCloseAPR = async () => {
    if (!assessmentStatus?.id) {
      message.error("No completed report found to close.");
      return;
    }

    setProgressLoad(true);
    const today = new Date().toISOString().split("T")[0];
    const assessmentStartDate = assessmentStatus?.assessmentStartDate || today;
    const assessmentEndDate = assessmentStatus?.assessmentEndDate || today;
    const reviewEndDate = assessmentStatus?.reviewEndDate || today;

    const payload = {
      id: assessmentStatus.id,
      username: user?.user?.username,
      fullName: user?.user?.fullName,
      userRole: normalizedUserRole,
      type: assessmentStatus.type || `RCC_APR_${selectedPeriod?.value || "Y"}`,
      districtId: selectedDistrict?.value,
      year: assessmentStatus.year || selectedYear?.value,
      status: "Closed",
      assessmentStartDate,
      assessmentEndDate,
      reviewStartDate: assessmentStatus?.reviewStartDate || assessmentEndDate,
      reviewEndDate,
      closedDate: today,
    };

    try {
      const response = await instance.put(`assessments/${payload.id}`, payload);
      setAssessmentStatus(response.data);
      message.success({
        content: (
          <div>
            <p>Progress report closed successfully</p>
          </div>
        ),
        duration: 3,
      });
    } catch (error) {
      console.error("Failed to Close Report:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      message.error(`Failed to Close Report: ${error.response?.data?.message || error.message}`);
    } finally {
      setProgressLoad(false);
    }
  };

  const handleTableSelection = (selectedOption) => {
    setSelectedTable(selectedOption);
    // No data reloading here - just updating the selected table state
  };

  const showConfirm = () => {
    Modal.confirm({
      title: 'Start Report',
      content: `Do you want to start the Progress Report for this region ?`,
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        handleStartAPR();
      },
      onCancel() {
        // Do nothing on cancel
      },
    });
  };

  const showPending = () => {
    Modal.confirm({
      title: 'SUBMIT APR TO APR DCE',
      content: `Do you want to submit this RCC progress report to APR DCE for validation?`,
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        handlePendingAPR();
      },
      onCancel() {
        // Do nothing on cancel
      },
    });
  };

  const showCompleted = () => {
    Modal.confirm({
      title: 'APPROVE RCC REPORT',
      content: `Do you want to approve this RCC progress report and forward it to NDPC?`,
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        handleCompleteAPR();
      },
      onCancel() {
        // Do nothing on cancel
      },
    });
  };

  const showSendBackToRcc = () => {
    Modal.confirm({
      title: 'SEND BACK TO RCC',
      content: `Do you want to reject this report and send it back to RCC for improvement?`,
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        handleSendBackAPR();
      },
    });
  };

  const showClosed = () => {
    Modal.confirm({
      title: 'CLOSE PROGRESS REPORT',
      content: `Do you want to close the progress report for this region?`,
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        handleCloseAPR();
      },
      onCancel() {
        // Do nothing on cancel
      },
    });
  };

  const hasSelectedDistrict = Boolean(selectedDistrict?.value);
  const isNdpcApproved = assessmentStatus?.status === "Completed" || assessmentStatus?.status === "Closed";
  const hideTableDis =
    !assessmentStatus ||
    (!isSuperuser &&
      ((isRccUser && assessmentStatus?.status !== "Start") ||
        (isAprDceUser && assessmentStatus?.status !== "Pending") ||
        (isNdpcUser && !isNdpcApproved)));
  const workflowStatus = assessmentStatus?.status || "Not started";
  const statusBadgeClassName =
    assessmentStatus?.status === "Closed"
      ? "border-destructive/20 bg-destructive/10 text-destructive"
      : assessmentStatus?.status === "Completed"
        ? "border-success/20 bg-success/10 text-success"
        : assessmentStatus?.status === "Pending"
          ? "border-warning/20 bg-warning/10 text-warning"
          : assessmentStatus?.status === "Start"
            ? "border-primary/20 bg-primary/10 text-primary"
            : "border-border bg-muted text-muted-foreground";
  const currentWorkspaceLabel =
    selectedTable?.value === "all_tables" ? "All APR tables" : selectedTable?.label || "APR workspace";
  const buttonTextStyle = { color: "#fff", fontSize: "13px", fontWeight: 600, fontFamily: "inherit" };
  const actionButtonSpacing = embedded ? {} : { marginTop: "10px" };
  const emptyDistrictMessage = embedded
    ? "Select a region from the left sidebar to load the RCC APR workspace."
    : "Select a region to load the RCC APR workspace.";

  const startReportAction =
    (hasSelectedDistrict && assessmentStatus === null && canStartRccReport)
      ? (
        <Button
          type="primary"
          onClick={showConfirm}
          style={{
            backgroundColor: "#16325a",
            borderColor: "#16325a",
            ...actionButtonSpacing,
          }}
          loading={progressLoad}
        >
          <span style={buttonTextStyle}>Start RCC Progress Report</span>
        </Button>
      ) : null;

  const submitToDceAction =
    (hasSelectedDistrict && assessmentStatus?.status === "Start" && canSubmitToDce) ? (
      <Button
        type="primary"
        onClick={showPending}
        style={{
          backgroundColor: "#b45309",
          borderColor: "#b45309",
          ...actionButtonSpacing,
        }}
        loading={progressLoad}
      >
        <span style={buttonTextStyle}>Submit Progress Report to APR DCE</span>
      </Button>
    ) : null;

  const approveRccAction =
    (hasSelectedDistrict && assessmentStatus?.status === "Pending" && canReviewAsDce) ? (
      <Button
        type="primary"
        onClick={showCompleted}
        style={{
          backgroundColor: "#047857",
          borderColor: "#047857",
          ...actionButtonSpacing,
        }}
        loading={progressLoad}
      >
        <span style={buttonTextStyle}>Approve RCC Report</span>
      </Button>
    ) : null;

  const sendBackToRccAction =
    (hasSelectedDistrict && assessmentStatus?.status === "Pending" && canReviewAsDce) ? (
      <Button
        type="primary"
        onClick={showSendBackToRcc}
        style={{
          backgroundColor: "#c2410c",
          borderColor: "#c2410c",
          ...actionButtonSpacing,
        }}
        loading={progressLoad}
      >
        <span style={buttonTextStyle}>Send Back to RCC</span>
      </Button>
    ) : null;

  const closeReportAction = (hasSelectedDistrict && assessmentStatus?.status === "Completed" && canCloseAsNdpc) ? (
      <Button
        type="primary"
        onClick={showClosed}
        style={{
          backgroundColor: "#b91c1c",
          borderColor: "#b91c1c",
          ...actionButtonSpacing,
        }}
        loading={progressLoad}
      >
        <span style={buttonTextStyle}>Close Current RCC Progress Report</span>
      </Button>
    ) : null;

  const exportFileBase = `${selectedDistrict?.label || "RCC"}_APR_Report_${selectedYear?.value || "Year"}_${getPeriodLabel()}`;
  const exportTitle = `${selectedDistrict?.label || "RCC"} Progress Report ${selectedYear?.value || ""}`.trim();

  const downloadReportAction = (
    <div style={actionButtonSpacing}>
      <AprExportButtons
        disabled={!hasSelectedDistrict}
        label="Download"
        onPdf={() => {
          if (!contentToPrint.current) {
            throw new Error("Report content is not available for PDF.");
          }
          handlePrint();
        }}
        onWord={() => {
          if (!contentToPrint.current) {
            throw new Error("Report content is not available for Word download.");
          }
          downloadAprReportWord(contentToPrint.current, {
            title: exportTitle,
            filename: exportFileBase,
          });
        }}
        onExcel={() => {
          if (!contentToPrint.current) {
            throw new Error("Report content is not available for Excel download.");
          }
          downloadAprReportExcel(contentToPrint.current, {
            title: exportTitle,
            filename: exportFileBase,
          });
        }}
      />
    </div>
  );

  // All components are always rendered but controlled via CSS display property
  const reportContent = (
    <>
      {embedded ? (
        <div className="apr-ws-header">
          <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <p style={{ margin: 0, fontSize: 11, fontWeight: 600, letterSpacing: "0.06em", textTransform: "uppercase", color: "rgba(255,255,255,0.65)" }}>
                RCC Progress Report
              </p>
              <h1>Annual Progress Report</h1>
              <p>
                Prepare, review, submit, and export RCC APR tables for the region selected in the sidebar.
              </p>
            </div>
            <div className="apr-ws-meta w-full lg:max-w-xl">
              <div className="apr-ws-meta-item">
                <p className="label">Year</p>
                <p className="value">{selectedYear?.value || "Not selected"}</p>
              </div>
              <div className="apr-ws-meta-item">
                <p className="label">Region</p>
                <p className="value">{selectedDistrict?.label || "Select in sidebar"}</p>
              </div>
              <div className="apr-ws-meta-item">
                <p className="label">Workflow</p>
                <p className="value" style={{ marginTop: 6 }}>
                  <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-medium ${statusBadgeClassName}`}>
                    {workflowStatus}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="page-header">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">Home</li>
            <li className="breadcrumb-item active">Annual Progress Report (APR)</li>
          </ol>
        </div>
      )}

      {/* Notification Section - Shows at the top when assessment exists */}
      {hasSelectedDistrict && notificationConfig && notificationConfig.show && (
        <div className={embedded ? "" : "mt-3"}>
          <Alert
            message={notificationConfig.message}
            description={notificationConfig.description}
            type={notificationConfig.type}
            showIcon
            icon={notificationConfig.icon}
            closable
            style={{
              marginBottom: 0,
              borderRadius: 8,
              fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, Arial, sans-serif',
              borderLeft: `4px solid ${
                notificationConfig.type === "success" ? "#047857" :
                notificationConfig.type === "warning" ? "#b45309" :
                notificationConfig.type === "info" ? "#16325a" : "#b91c1c"
              }`,
            }}
          />
        </div>
      )}

      <div className={embedded ? "space-y-4" : "main-container"}>
        <div className={embedded ? "apr-ws-shell apr-ws-section" : ""}>
          {embedded && (
            <p className="apr-ws-section-title" style={{ marginBottom: 10 }}>
              Report filters
            </p>
          )}
          <div className={embedded ? "apr-ws-filters" : "row gutters mb-3"}>
            <div className={embedded ? "" : "col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12"}>
              {embedded && <label className="apr-ws-filter-label">Year</label>}
              <Select
                onChange={(val) => setSelectedYear(val)}
                options={yearOptions}
                value={selectedYear}
                placeholder="Select Year"
                isSearchable
              />
            </div>

            <div className={embedded ? "" : "col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12"}>
              {embedded && <label className="apr-ws-filter-label">Period</label>}
              <Select
                onChange={setSelectedPeriod}
                options={periodOption}
                value={selectedPeriod}
                placeholder="Select Report Period"
              />
            </div>

            <div className={embedded ? "" : "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12"}>
              {embedded && <label className="apr-ws-filter-label">Table</label>}
              <Select
                onChange={handleTableSelection}
                options={tableOptions}
                value={selectedTable}
                isSearchable
                placeholder="Select Table"
              />
            </div>

            <div className={embedded ? "" : "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12"}>
              {embedded && <label className="apr-ws-filter-label">Abbreviation</label>}
              <Select
                onChange={setSelectedABB}
                options={Abbreviation}
                value={selectedABB}
                isSearchable
                placeholder="Select Abbreviation"
              />
            </div>
          </div>
        </div>

        <div className={embedded ? "apr-ws-shell" : ""}>
          {embedded && (
            <div className="apr-ws-section border-b border-slate-200">
              <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
                <div>
                  <p className="apr-ws-section-title">Report Workspace</p>
                  <h2 className="apr-ws-section-heading">{currentWorkspaceLabel}</h2>
                </div>
                <p className="m-0 text-sm text-slate-500">
                  {selectedDistrict?.label || "Select a region"} · {selectedYear?.value || "Year"} ·{" "}
                  {selectedPeriod?.label || "Period"}
                </p>
              </div>
            </div>
          )}

          <div className={embedded ? "apr-ws-section space-y-4" : "row gutters mb-3"}>
            {embedded ? (
              <div className="apr-ws-actions">
                {startReportAction}
                {submitToDceAction}
                {approveRccAction}
                {sendBackToRccAction}
                {closeReportAction}
                <div className="sm:ml-auto">{downloadReportAction}</div>
              </div>
            ) : (
              <>
                <Col span={10} className="gutter-row">
                  {startReportAction}
                </Col>
              </>
            )}

            {!hasSelectedDistrict && (
              <div className={embedded ? "apr-ws-empty" : "card"}>
                {embedded ? (
                  <p className="m-0">{emptyDistrictMessage}</p>
                ) : (
                  <div className="card-body">
                    <p>{emptyDistrictMessage}</p>
                  </div>
                )}
              </div>
            )}

            {hasSelectedDistrict && (
              <div ref={contentToPrint} className="apr-report-print-root apr-ws-content">
                {/* Report Cover - always visible */}
                <div className="row gutters">
                  {selectedDistrict && selectedYear && (
                    <ReportCover
                      district={selectedDistrict}
                      year={selectedYear?.value}
                      period={selectedPeriod?.label}
                      locationType="Region" />
                  )}
                </div>

                {assessmentStatus &&
                  <>
                    {(
                      <>
                        <WorkFlowComponent
                          year={selectedYear?.value}
                          district={selectedDistrict?.value}
                          hideTableDis={hideTableDis}
                          assessmentStatus={assessmentStatus}
                          tableCommented={`RCC_APR_Executive_${selectedPeriod?.value}`}
                          type={'RCC_APR'}
                          userRole={rccUserRole}
                          item="Executive Summary"
                        />
                      </>
                    )}


                    <h2 style={{ textAlign: "center" }}>CHAPTER ONE (1)</h2>
                    {(
                      <>
                        <WorkFlowComponent
                          year={selectedYear?.value}
                          district={selectedDistrict?.value}
                          hideTableDis={hideTableDis}
                          assessmentStatus={assessmentStatus}
                          tableCommented={`RCC_APR_GInformation_${selectedPeriod?.value}`}
                          type={'RCC_APR'}
                          userRole={rccUserRole}
                          item="General Information"
                        />
                      </>
                    )}</>}

                {/* All Tables - visible only when "all_tables" is selected */}
                <div style={{ display: selectedTable?.value === "all_tables" ? "block" : "none" }}>
                  <Annex2a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                    assessmentStatus1={assessmentStatus?.status !== "Closed"}
                    normalizedUserRole={normalizedUserRole?.status === "NDPC USER"}
                  />

                  <Annex2b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />

                  <h2 style={{ textAlign: "center" }}>CHAPTER TWO (2)</h2>

                  <Annex3b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />

                  <Annex3c
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />

                  <Annex4a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />

                  <Annex5a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />

                  <Annex5b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                    regionName={selectedRegion}
                  />

                  <Annex7c
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />

                  {(dataElements && categories && districtWideConstant) && (
                    <Annex6a
                      year={selectedYear?.value}
                      district={selectedDistrict?.value}
                      categories={categories}
                      dataElements={dataElements}
                      districtWideConstant={districtWideConstant}
                      economicDataElements={economicDataElements}
                      socialDataElements={socialDataElements}
                      period={selectedPeriod?.value}
                      hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                    />
                  )}

                  <Annex7a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />


                  <Annex8a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />

                  <Annex8b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />

                  <Annex8c
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />

                  <Annex9a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />

                  {assessmentStatus && (
                    <>
                      <h2 style={{ textAlign: "center" }}>CHAPTER THREE (3)</h2>

                      <WorkFlowComponent
                        year={selectedYear?.value}
                        district={selectedDistrict?.value}
                        hideTableDis={hideTableDis}
                        assessmentStatus={assessmentStatus}
                        tableCommented={`RCC_APR_Introduction_${selectedPeriod?.value}`}
                        type={'RCC_APR'}
                        userRole={rccUserRole}
                        item="Introduction"
                      />

                      <WorkFlowComponent
                        year={selectedYear?.value}
                        district={selectedDistrict?.value}
                        hideTableDis={hideTableDis}
                        assessmentStatus={assessmentStatus}
                        tableCommented={`RCC_APR_KeyIssues_Addressed_${selectedPeriod?.value}`}
                        type={'RCC_APR'}
                        userRole={rccUserRole}
                        item="Key Issues Addressed"
                      />

                      <WorkFlowComponent
                        year={selectedYear?.value}
                        district={selectedDistrict?.value}
                        hideTableDis={hideTableDis}
                        assessmentStatus={assessmentStatus}
                        tableCommented={`RCC_APR_KeyIssuesYetToBe_Addressed_${selectedPeriod?.value}`}
                        type={'RCC_APR'}
                        userRole={rccUserRole}
                        item="Key Issues Yet to be Addressed"
                      />

                      <WorkFlowComponent
                        year={selectedYear?.value}
                        district={selectedDistrict?.value}
                        hideTableDis={hideTableDis}
                        assessmentStatus={assessmentStatus}
                        tableCommented={`RCC_APR_Recommendations_${selectedPeriod?.value}`}
                        type={'RCC_APR'}
                        userRole={rccUserRole}
                        item="Recommendations"
                      />

                      <WorkFlowComponent
                        year={selectedYear?.value}
                        district={selectedDistrict?.value}
                        hideTableDis={hideTableDis}
                        assessmentStatus={assessmentStatus}
                        tableCommented={`RCC_APR_Conclusion_${selectedPeriod?.value}`}
                        type={'RCC_APR'}
                        userRole={rccUserRole}
                        item="Conclusion"
                      />

                     {assessmentStatus?.status === "Completed" ? <WorkFlowComponent
                        year={selectedYear?.value}
                        district={selectedDistrict?.value}
                        hideTableDis={hideTableDis}
                        assessmentStatus={assessmentStatus}
                        tableCommented={`RCC_APR_NDPCSummary_${selectedPeriod?.value}`}
                        type={'RCC_APR'}
                        userRole={rccUserRole}
                        item="NDPC Summary of RCC Progress Report"
                      />: <></>}

                    </>)}
                </div>

                {/* Individual Tables - each visible only when its specific table is selected */}
                <div style={{ display: selectedTable?.value === "table_1" ? "block" : "none" }}>
                  <Annex2a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                    assessmentStatus1={assessmentStatus?.status !== "Closed"}
                    normalizedUserRole={normalizedUserRole?.status === "NDPC USER"}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_2" ? "block" : "none" }}>
                  <Annex2b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_3" ? "block" : "none" }}>
                  <Annex3b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_4" ? "block" : "none" }}>
                  <Annex3c
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_5" ? "block" : "none" }}>
                  <Annex4a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_6" ? "block" : "none" }}>
                  <Annex5a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_5b" ? "block" : "none" }}>
                  <Annex5b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                    regionName={selectedRegion}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_7" ? "block" : "none" }}>
                  {(dataElements && categories && districtWideConstant) && (
                    <Annex6a
                      year={selectedYear?.value}
                      district={selectedDistrict?.value}
                      categories={categories}
                      dataElements={dataElements}
                      districtWideConstant={districtWideConstant}
                      economicDataElements={economicDataElements}
                      socialDataElements={socialDataElements}
                      period={selectedPeriod?.value}
                      hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                    />
                  )}
                </div>

                <div style={{ display: selectedTable?.value === "table_8" ? "block" : "none" }}>
                  <Annex7a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_9" ? "block" : "none" }}>
                  <Annex8a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_10" ? "block" : "none" }}>
                  <Annex8b
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_11" ? "block" : "none" }}>
                  <Annex8c
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />
                </div>

                <div style={{ display: selectedTable?.value === "table_12" ? "block" : "none" }}>
                  <Annex9a
                    year={selectedYear?.value}
                    district={selectedDistrict?.value}
                    period={selectedPeriod?.value}
                    hideTableDis={hideTableDis}
                    assessmentStatus={assessmentStatus}
                  />
                </div>

              </div>
            )}

            {hasSelectedDistrict && !embedded && (
              <>
                <Col span={10} className="gutter-row">
                  {submitToDceAction}
                </Col>

                <Col span={10} className="gutter-row">
                  {approveRccAction}
                </Col>

                <Col span={10} className="gutter-row">
                  {sendBackToRccAction}
                </Col>

                <Col span={10} className="gutter-row">
                  {closeReportAction}
                </Col>

                <div style={{ textAlign: "right" }}>
                  {downloadReportAction}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );

  if (embedded) {
    return <div className="main-content space-y-4 apr-report-page">{reportContent}</div>;
  }

  return (
    <div className="page-content apr-report-page">
      {reportContent}
    </div>
  );
}

export default AprReport;